// Playback correlation — create a bounded opaque identifier for one tune/handoff.
export function createPlaybackAttemptId(): string {
    try {
        const bytes = new Uint8Array(12);
        crypto.getRandomValues(bytes);
        return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
    } catch {
        return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
    }
}

export function isPlaybackAttemptId(value: unknown): value is string {
    return typeof value === 'string' && /^[A-Za-z0-9_-]{8,64}$/.test(value);
}
